import React from 'react';
import styled from 'styled-components';
import { QuestionCircleOutlined } from '@ant-design/icons';

export const PopoverComponent = styled('div')`
  width: 500px;
`;

export const PopoverIconMark = styled('div')`
  .anticon-question-circle {
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const QuestionIcon = styled(
  ({
    color,
    ...props
  }: { color?: string } & React.ComponentProps<
    typeof QuestionCircleOutlined
  >) => <QuestionCircleOutlined {...props} />,
)`
  color: ${({ color }) => color};
  margin-left: 8px;
  cursor: pointer;
`;
